<template>

</template>

<script>
export default {
  name: "UserManagersCard"
}
</script>

<style scoped>

</style>
